import { useEffect, type ReactNode } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  title: string;
  onClose: () => void;
  footer?: ReactNode;
  children: ReactNode;
  maxWidth?: number;
}

/** Базовый модальный диалог с backdrop, sticky-шапкой и опциональным футером. */
export function Modal({ title, onClose, footer, children, maxWidth = 560 }: ModalProps) {
  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onEsc);
    return () => window.removeEventListener('keydown', onEsc);
  }, [onClose]);

  return (
    <>
      <div
        className="fixed inset-0 z-50 backdrop-blur-sm"
        style={{ background: 'rgba(10,22,40,.6)' }}
        onClick={onClose}
      />
      <div
        className="fixed z-50 bg-white rounded-card flex flex-col border border-border"
        style={{
          top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
          width: 'calc(100% - 32px)', maxWidth, maxHeight: '90vh',
          boxShadow: '0 24px 64px rgba(10,22,40,.24)',
        }}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <header className="flex items-center justify-between border-b border-border" style={{ padding: '20px 24px' }}>
          <h3 id="modal-title" className="font-heading text-ink" style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.01em' }}>
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="text-muted hover:text-ink"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
            aria-label="Закрыть"
          ><X size={20} /></button>
        </header>
        <div className="flex-1 overflow-y-auto" style={{ padding: 24 }}>
          {children}
        </div>
        {footer && (
          <footer className="flex items-center justify-end border-t border-border" style={{ padding: '16px 24px', gap: 12 }}>
            {footer}
          </footer>
        )}
      </div>
    </>
  );
}
